function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.28358 14.336L18.5046 7.18437C18.5076 7.18265 18.51 7.18018 18.5117 7.1772C18.5134 7.17423 18.5143 7.17085 18.5143 7.16742C18.5143 7.16399 18.5134 7.16062 18.5117 7.15764C18.51 7.15467 18.5076 7.1522 18.5046 7.15047L6.31354 0.00274731C6.31061 0.00103253 6.30729 0.000127304 6.3039 0.000122093C6.30052 0.000116882 6.2972 0.00101189 6.29426 0.00271763C6.29133 0.00442338 6.28889 0.00688006 6.28718 0.00984225C6.28548 0.0128045 6.28457 0.0161684 6.28455 0.0195978L6.28358 14.336Z",
  fill: "url(#paint0_linear_6473_550)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.28358 5.59607L13.7489 9.96602L6.28358 14.336V5.59607Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_6473_550",
  x1: 3.39215,
  y1: -3.80075,
  x2: 14.1587,
  y2: 13.1188,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003E68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F3F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_6473_550",
  x1: -0.715031,
  y1: 3.50706,
  x2: 10.8515,
  y2: 19.0285,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00FFF8"
})));

function SvgGiblibIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M0.0289879 17.9973L13.7499 9.96607L0.0289879 1.93488C0.0260445 1.93315 0.0227049 1.93225 0.0193061 1.93225C0.0159073 1.93225 0.0125695 1.93317 0.00962938 1.9349C0.0066893 1.93662 0.00425098 1.93911 0.00256036 1.9421C0.000869744 1.94509 -1.33714e-05 1.94848 1.53035e-07 1.95192V17.9804C2.04984e-05 17.9839 0.000928278 17.9872 0.00263272 17.9902C0.00433716 17.9931 0.00677856 17.9956 0.00971294 17.9973C0.0126473 17.999 0.0159719 17.9999 0.0193544 17.9999C0.0227368 17.9999 0.0260586 17.999 0.0289879 17.9973Z",
    fill: "url(#paint1_linear_6473_550)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.75
  }, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiblibIcon);
export default __webpack_public_path__ + "static/media/Giblib_icon.bd3650d9.svg";
export { ForwardRef as ReactComponent };